import type { ReactNode } from 'react';

interface FormSectionProps {
  title: ReactNode;
  children: ReactNode;
}

const FormSection = ({ title, children }: FormSectionProps) => (
  <div className='w-full p-5 bg-white rounded-lg shadow-md flex flex-col gap-4'>
    <h3 className='text-gray-800 font-semibold'>{title}</h3>
    {children}
  </div>
);

export default FormSection;
